import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import './LoginPage.css';
import { apiEndpoint } from '../config/api';

const ME_API_URL = process.env.REACT_APP_ME_API_URL || apiEndpoint('api/me.php');
export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('checking');
  useEffect(() => {
    const token = sessionStorage.getItem('demo_auth_token') || localStorage.getItem('demo_auth_token');
    if (!token) { setStatus('denied'); return; }
    fetch(ME_API_URL, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => { if (!response.ok) throw new Error(); return response.json(); })
      .then(() => setStatus('allowed'))
      .catch(() => { sessionStorage.removeItem('demo_auth_token'); localStorage.removeItem('demo_auth_token'); setStatus('denied'); });
  }, []);
  if (status === 'checking') return <div className="login-auth-overlay"><div className="login-auth-spinner" /><strong>Đang xác thực quyền truy cập</strong><span>Vui lòng chờ trong giây lát...</span></div>;
  if (status === 'denied') return <Navigate to="/login" replace />;
  return children;
}
